import { render, staticRenderFns } from "./SightItem.vue?vue&type=template&id=ab96cf90&"
import script from "./SightItem.vue?vue&type=script&lang=js&"
export * from "./SightItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SightItem.vue"
export default component.exports